module.exports = __webpack_public_path__ + "img/mission-gfp-gfy-banner.jpg?9b542c89dd604ad1c95b520435b76887";